import React from 'react';
import Canvas from './Canvas';
import GuestName from './GuestName';

const Intro = () => (
  <Canvas spanClass="span8">
    <center>
      <h1 className="bijt logo">IRIS + JIMMY</h1>
      <h3>Lionel First Birthday Quiz</h3>
      <hr style={{ margin: '20px 0' }} className="bijt short-hr" />
      <GuestName />
    </center>
  </Canvas>
);

export default Intro;


// WEBPACK FOOTER //
// ./src/components/Intro.js